export const isFederation = process.env.FEDERATION === 'true'
export const isProdEnv = process.env.ENVIRONMENT === 'production'
